import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyDvINX4qX12Xa6_ylYNSEGEaKP_SrCBQ2I",
    authDomain: "timewarden-2912e.firebaseapp.com",
    projectId: "timewarden-2912e",
    storageBucket: "timewarden-2912e.firebasestorage.app",
    messagingSenderId: "502666258035",
    appId: "1:502666258035:web:79b566474f1decf5612c06",
    measurementId: "G-SY57CL1CGD"
};
const app = initializeApp(firebaseConfig);

// Initialize all required services
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app); // Initialize functions

// Export everything
export { db, auth, functions };